import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import stripebadge from '../assets/stripebadge.png';

import { Typography, TextField, Paper, Button, Tooltip } from '@material-ui/core'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { Order, PatronOrder } from '../models/Order'
import { AccountRequest } from '../models/Account'
import { RestComponent } from 'react-frontend-utils'

import { StripeManager } from 'react-frontend-utils'

/**
 * 
 * Checkout page for a single database's Patron Portal.  
 * 
 * The caller must pass the props:
 * 
 * returnToStore:    a function to be called to go back to the Store page
 * purchaseComplete: a function to be called when purchasing is complete (passing the accountID and true if there was a charge, false if free)
 * database:         database (PublicJsonGroup) retrieved from GET /patron/databases/{databaseName}
 * account:          a PublicAccount object if the portal was visited using a referrer link, null otherwise (for guest)
 * checkout:         an object containing:
 *                      name:            if guest, the name, otherwise ingored if account is set
 *                      email:           if guest, the email, otherwise ingored if account is set
 *                      cart:            the products to buy
 *                      funds:           the funds to add
 *                      serviceFee:      the service fees calculated
 *                      membershipInfo:  the membership info, if required
 *                      isFree:          true if the total for checkout is zero
 *
 *
 * If no account is set, provide text entry for name and email.
 * 
 * The StripeManager component takes care of the purchase. It calls the requestPurchase function to submit the order to the server 
 * and receive the client secret to use to complete the payment
 *
 */

export class Checkout extends RestComponent {

    styles = {
        paperLabel: {
            color: 'blue',
            fontSize: '12pt',
            flexGrow: 1
        }
    }

    _name;
    _email;
        
    constructor(props) {
        super(props);
        this.state.cardChargeFailure = false;
        this.state.checkedOutAccount = null;  //The account that was charged / took free items
        this.state.clientSecret = null;  //The client secret returned from the server to complete the purchase (null if free or not retrieved yet)
   
        if (this.props.account) {  //existing customer checkout
            this._name = this.props.account.name;
            this._email = this.props.account.email;
        }
        else {  //guest - use user entered fields
            this._name = this.props.checkout.name;
            this._email = this.props.checkout.email;
        } 
    
    }


    componentDidMount() {
        if (!this.props.checkout.isFree)
            this._requestPurchase();  //If not free, immediately request the purchase to get the client secret.  If free, wait until user clicks the button to request the free purchase
    }

    _returnToStore = () => {
        this.setState({cardChargeFailure: false});
        this.props.returnToStore();
    }

    _requestPurchase = () => {
        
        const accountID = this.props.account ? this.props.account.id : null;
                
        //Create a Order from the cart.  The account may be null if guest.  No comment provided.
        const order = Order.createFromCheckout(true, this.props.checkout.cart, accountID, this.props.checkout.membershipInfo, null);
        
        let guestAccount = null;
        if (this.props.account == null) {
            console.log("Creating order as guest (" + this.state.name + ")");
            guestAccount = new AccountRequest(this._name, this._email);
        }
        else {
            console.log("Creating order for existing patron");
        }
        
        //Create the Patron order with the guest account (null if existing account), the order, and requested funds
        const patronOrder = new PatronOrder(guestAccount, order, this.props.checkout.funds, this.props.checkout.serviceFee, this.props.database.isoCurrency);
                
        this.secureJSONFetch("/patron/databases/" + this.props.database.name + "/order",
                             {method: "POST", body: JSON.stringify(patronOrder)}, 
                             this._orderSucceeded, 
                             this._orderFailed);
    }


    _orderSucceeded = (response) => {
        if (response) {  //response is JsonOrderSuccess (two elements)          
            const clientSecret = response.clientSecret;
            this.setState({checkedOutAccount: response.accountID, clientSecret: clientSecret});  //store the account and client secret in state to complete the purchase in StripeManager
            if (!clientSecret) {  //If no client secret, this was a free purchase, so complete the purchase immediately
                this._freeItemSucceed();
            }
        }
    }
    
    _orderFailed = (errorResponse) => {
        this.showConfirmAlert("Purchase Failed", errorResponse + ". Your card has not been charged. Return to the Store and try again.", 'red');
    }


    _chargeSuccess = () => {
        this.props.purchaseComplete(this.state.checkedOutAccount, true);  //purchase complete with the account, true = money was charged
    }
    
    _freeItemSucceed = () => {
        this.props.purchaseComplete(this.state.checkedOutAccount, false);  //purchase complete with the account, false = items were free
        this.forceUpdate();
    }
    
    _freeItemFailure = (message) => {      
        this.showConfirmAlert("Order Failed", message + " You can try again or return to the Store.", 'red'); 
    }


    render() {
        
        console.log(this.props.checkout);

        
                
        return (
            <Fragment>

                {this.getConfirmAlertComponent()}

                <Button color="primary" style={{marginBottom: 20}} onClick={this._returnToStore}>
                    <ArrowBackIosIcon fontSize='small'/> 
                    <Typography variant="body1">Back to Store</Typography>   
                </Button>  
                
                {this.props.checkout.isFree ? 
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <Button onClick={() => this._requestPurchase(this._freeItemSucceed, this._freeItemFailure)} 
                                variant="contained" color="primary" style={{color: 'white'}}>Request Free Products</Button>
                    </div>
                    :
                    null
                }
                {this.state.clientSecret ?
                    <div>
                        <StripeManager  email={this._email}  
                                        clientSecret={this.state.clientSecret}
                                        paymentSuccess={this._chargeSuccess}/>

                        <div style={{display: 'flex', justifyContent: 'center', marginTop: 100}}>

                            <a href="https://www.stripe.com" target="_blank" rel="noopener noreferrer">
                                {<img src={stripebadge} alt="stripe badge" width='400px'/>}
                            </a>

                        </div>
                    </div>  
                    :
                    null                        
                }
                
            </Fragment>
        );
    }

}

export default withCookies(Checkout);
